import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/metaPixel';

/**
 * Tracks a PageView on initial load and on SPA route transitions.
 */
const MetaPixelTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const pageKey = `${location.pathname}${location.search}${location.hash}`;
        trackPageView(pageKey);
    }, [location.pathname, location.search, location.hash]);

    return null;
};

export default MetaPixelTracker;
